import update from '../modules/image-tools'
var sizes = require('../modules/sizes'),
  images = require('../modules/image-tools'),
  _sizesToCheck = ['xs', 'xxs', 'sm'];


var _initIfRightSize = function () {
  for (var i in _sizesToCheck) {
    var s = _sizesToCheck[i];
    /* jshint ignore:start */
    $('.project-' + ((s === 'xxs') ? 'xs' : s) + '-slider').each(function () {
      var $toBeSlider = $(this);
      if (!$toBeSlider.is('.slick-slider') && sizes.verifySize(s)) {
        $toBeSlider.on('init', function () {
          images.update();
        });
        $toBeSlider.slick({ dots: true });
      }
    });
    /* jshint ignore:end */
  }
};

$().ready(function () {
  _initIfRightSize();
});

$(window).resize(function () {
  _initIfRightSize();
});


$(document).ready(function(){
    $('.career-slider').slick({
        arrows:false,
        dots:true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
  });
});
